__turbopack_context__.v({
  "backdrop": "Modal-module__7xkgQW__backdrop",
  "body": "Modal-module__7xkgQW__body",
  "modal": "Modal-module__7xkgQW__modal",
  "root": "Modal-module__7xkgQW__root",
});
